export const FLIGHT_LIMITS = {
  MAX_PASSENGERS: 9,
  MIN_ADULTS: 1,
  MAX_FLIGHTS: 5,
  MIN_MULTI_CITY_FLIGHTS: 2,
} as const;

export const CHILD_AGE_LIMITS = {
  MIN: 2,
  MAX: 11,
} as const;

export const TRIP_TYPES = [
  { label: "One Way", value: "oneway" },
  { label: "Round Trip", value: "roundtrip" },
  { label: "Multi City", value: "multicity" },
] as const;

export const CABIN_TYPES = [
  { label: "Economy", value: "1" },
  { label: "Premium Economy", value: "2" },
  { label: "Business", value: "3" },
  { label: "First Class", value: "4" },
] as const;

export const PASSENGER_TYPES_LIST = ["adults", "children", "infants"] as const;
